import { useEffect, useRef, useState } from 'react'

/**
 * Measures an element's rendered width.
 *
 * Charts need this because an SVG with a fixed viewBox scales its text along with
 * everything else: 9.5px type in a 760-wide viewBox renders at ~4px inside a 330px
 * small-multiple card. Drawing at the real pixel width keeps font sizes true.
 */
export function useMeasure<T extends HTMLElement>(fallback = 760) {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(fallback)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width
      if (w && w > 0) setWidth(Math.round(w))
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  return [ref, width] as const
}
